import { render, staticRenderFns } from "./DefaultAdmin.vue?vue&type=template&id=7f56e6cc&scoped=true"
import script from "./DefaultAdmin.vue?vue&type=script&lang=js"
export * from "./DefaultAdmin.vue?vue&type=script&lang=js"
import style0 from "./DefaultAdmin.vue?vue&type=style&index=0&id=7f56e6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56e6cc",
  null
  
)

export default component.exports